// extracted by mini-css-extract-plugin
module.exports = {"scrollHidden":"WithCurriculumLayout_scrollHidden__Gcghq"};